module.exports = __webpack_public_path__ + "img/philia-1.b12a149f.jpg";